var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getEnv } from "@/shared/utils/env";
var SSOApiDatasource = /** @class */ (function () {
    function SSOApiDatasource(httpClient, baseUrl) {
        if (baseUrl === void 0) { baseUrl = getEnv("SSO_URL"); }
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
    }
    SSOApiDatasource.prototype.getUserPermissions = function () {
        return this.httpClient
            .request({
            method: "get",
            url: "/auth/permissions",
            baseUrl: this.baseUrl,
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    SSOApiDatasource.prototype.isUserAccountValidated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            baseUrl: this.baseUrl,
                            method: "POST",
                            url: "/users/validated",
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.body];
                }
            });
        });
    };
    SSOApiDatasource.prototype.renewToken = function (email) {
        return this.httpClient
            .request({
            method: "post",
            body: { email: email },
            url: "/auth/check-email",
            baseUrl: this.baseUrl,
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    SSOApiDatasource.prototype.loginWithCockpit = function (email) {
        return this.httpClient
            .request({
            method: "post",
            body: { email: email },
            url: "/cockpit",
            baseUrl: this.baseUrl,
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    SSOApiDatasource.prototype.cockpitLogout = function () {
        return this.httpClient
            .request({
            method: "get",
            url: "/cockpit/logout",
            baseUrl: this.baseUrl,
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    SSOApiDatasource.prototype.changePassword = function (password) {
        return this.httpClient
            .request({
            method: "PATCH",
            body: { password: password },
            url: "/auth/me/change-password",
            baseUrl: this.baseUrl,
        })
            .then(function (_a) {
            var body = _a.body;
            return body;
        });
    };
    SSOApiDatasource.prototype.generateQrCode = function () {
        return this.httpClient
            .request({
            method: "POST",
            url: "/2fa/generate-qrcode",
            baseUrl: this.baseUrl,
        })
            .then(function (_a) {
            var body = _a.body;
            return body.qrcode;
        });
    };
    SSOApiDatasource.prototype.toggleTfa = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "POST",
                            url: "/2fa/toggle",
                            baseUrl: this.baseUrl,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SSOApiDatasource.prototype.removerTfaPin = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "POST",
                            url: "/2fa/recover",
                            baseUrl: this.baseUrl,
                            body: { email: email },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SSOApiDatasource.prototype.validateTfaToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "POST",
                            url: "/2fa/validate-token",
                            baseUrl: this.baseUrl,
                            body: { token: token },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SSOApiDatasource.prototype.askToJoin = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "POST",
                            url: "/auth/ask-to-join",
                            baseUrl: this.baseUrl,
                            body: __assign({}, payload),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SSOApiDatasource.prototype.getRequestsJoin = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.httpClient
                        .request({
                        method: "GET",
                        url: "/users/requests-join",
                        baseUrl: this.baseUrl,
                    })
                        .then(function (_a) {
                        var body = _a.body;
                        return body;
                    })];
            });
        });
    };
    SSOApiDatasource.prototype.approveRequestJoinId = function (requestJoinId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "PATCH",
                            url: "/users/requests-join/" + requestJoinId + "/approve",
                            baseUrl: this.baseUrl,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SSOApiDatasource.prototype.rejectRequestJoinId = function (requestJoinId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request({
                            method: "PATCH",
                            url: "/users/requests-join/" + requestJoinId + "/reject",
                            baseUrl: this.baseUrl,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SSOApiDatasource.prototype.refreshToken = function (token, refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, newToken, newRefreshToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.httpClient
                            .request({
                            method: "POST",
                            url: "auth/refresh-token",
                            baseUrl: this.baseUrl,
                            body: { token: refreshToken },
                            headers: { authorization: "Bearer " + token },
                        })
                            .then(function (response) { return response.body; })];
                    case 1:
                        _a = (_b.sent()), newToken = _a.token, newRefreshToken = _a.refreshToken;
                        return [2 /*return*/, {
                                token: newToken,
                                refreshToken: newRefreshToken,
                            }];
                }
            });
        });
    };
    SSOApiDatasource.prototype.changeProfile = function (clientRockId, typeProfile) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, newToken, newRefreshToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.httpClient
                            .request({
                            method: "POST",
                            url: "users/change-profile",
                            baseUrl: this.baseUrl,
                            body: { clientRockId: clientRockId, typeProfile: typeProfile },
                        })
                            .then(function (response) { return response.body; })];
                    case 1:
                        _a = (_b.sent()), newToken = _a.token, newRefreshToken = _a.refreshToken;
                        return [2 /*return*/, {
                                token: newToken,
                                refreshToken: newRefreshToken,
                            }];
                }
            });
        });
    };
    SSOApiDatasource.prototype.getUser = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient
                            .request({
                            method: "GET",
                            url: "users/" + email,
                            baseUrl: this.baseUrl,
                        })
                            .then(function (response) { return response.body; })];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        });
    };
    return SSOApiDatasource;
}());
export { SSOApiDatasource };
